import * as React from "react";

import { cn } from "../../lib/utils";

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex px-3 py-1 w-full h-9 text-base bg-transparent rounded-md border shadow-sm transition-colors border-input file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      onWheel={e => {
        if (type === "number") {
          e.target.blur();
        }
      }}
      onKeyDown={e => {
        if (type === "number" && (e.key === "ArrowUp" || e.key === "ArrowDown")) {
          e.preventDefault();
        }
      }}
      {...props}
    />
  );
});
Input.displayName = "Input";

export { Input };
